// extracted by mini-css-extract-plugin
export default {"mainHero":"Shop_mainHero__puyiP","productSection":"Shop_productSection__RAqaf"};